// import React, { useState } from 'react';
// import axios from 'axios'

// // const Step3 = ({ success, nextStep, setReportData }) => {
// const Step3 = ({ success, nextStep, setReportData, selectedEntries, setSelectedEntries }) => {
//     const [fromDate, setFromDate] = useState('');
//     const [toDate, setToDate] = useState('');
//     const [reportType, setReportType] = useState('all');
//     const [isGenerating, setIsGenerating] = useState(false);
//     const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);
//     const [error, setError] = useState('');
//     const [reportGenerated, setReportGenerated] = useState(false);
//     const [localReportData, setLocalReportData] = useState(null);

//     const [showMatchedOnly, setShowMatchedOnly] = useState(false);






//     // For matched entries

//     // Filter transactions based on toggle
//     const filteredEntries = showMatchedOnly
//         ? localReportData?.summary?.detailedEntries.filter(entry => entry.status === 'Matched')
//         : localReportData?.summary?.detailedEntries;

//     // Calculate matched-only totals
//     const matchedTotals = localReportData?.summary?.detailedEntries
//         .filter(entry => entry.status === 'Matched')
//         .reduce((acc, entry) => ({
//             totalCollections: acc.totalCollections + entry.customerAmount,
//             totalPayable: acc.totalPayable + entry.payableToPartner,
//             platformEarnings: acc.platformEarnings + entry.platformEarnings,
//             gatewayCharges: acc.gatewayCharges + entry.gatewayCharges,
//             taxes: acc.taxes + entry.taxes,
//             count: acc.count + 1
//         }), {
//             totalCollections: 0,
//             totalPayable: 0,
//             platformEarnings: 0,
//             gatewayCharges: 0,
//             taxes: 0,
//             count: 0
//         });


//     // Sample data structure that includes both Taxi and Theater
//     // const sampleReportData = {
//     //   _id: "rep_123456",
//     //   generatedAt: new Date().toISOString(),
//     //   periodStart: "2023-01-01",
//     //   periodEnd: "2023-01-31",
//     //   reportType: "all",
//     //   summary: {
//     //     totalCollections: 125000,
//     //     totalPayableToPartners: 100000,
//     //     totalPlatformEarnings: 25000,
//     //     netPayableToPlatform: 25000,
//     //     totalGatewayCharges: 5000,
//     //     totalTaxes: 7000,
//     //     serviceWiseBreakdown: {
//     //       taxi: {
//     //         count: 150,
//     //         totalAmount: 75000,
//     //         payableToDriver: 60000,
//     //         platformEarnings: 15000
//     //       },
//     //       theater: {
//     //         count: 100,
//     //         totalAmount: 50000,
//     //         payableToTheater: 40000,
//     //         platformEarnings: 10000
//     //       }
//     //     },
//     //     detailedEntries: [
//     //       // Taxi entries
//     //       {
//     //         serviceType: "taxi",
//     //         transactionId: "txn_001",
//     //         customerAmount: 500,
//     //         payableToPartner: 400,
//     //         platformEarnings: 100,
//     //         taxes: 50,
//     //         status: "Matched",
//     //         date: "2023-01-15"
//     //       },
//     //       // Theater entries
//     //       {
//     //         serviceType: "theater",
//     //         transactionId: "tkt_001",
//     //         customerAmount: 1000,
//     //         payableToPartner: 800,
//     //         platformEarnings: 200,
//     //         taxes: 100,
//     //         status: "Matched",
//     //         date: "2023-01-10"
//     //       },
//     //       // More entries...
//     //     ]
//     //   }
//     // };

//     const generateReport = async () => {
//         if (!fromDate || !toDate) {
//             setError('Please select both date ranges');
//             return;
//         }

//         setIsGenerating(true);
//         setError('');

//         try {
//             // Simulating API call with sample data
//             // In real implementation, you would use:
//             // const response = await axios.post('http://localhost:8080/generateReport', { fromDate, toDate, reportType });
//             // setReportData(response.data);
//             console.log('before sending a data', fromDate, toDate, reportType)


//             const response = await axios.post('http://localhost:8080/generateReport', {
//                 // const response = await axios.post('https://admin-api.cruze.asia/generateReport', {
//                 fromDate,
//                 toDate,
//                 reportType
//             });

//             console.log('response===================================', response);

//             // setReportData(response.data.report);

//             console.log('respone data', response?.data?.report)
//             // Using sample data for demonstration
//             setReportData(response.data.report);
//             setLocalReportData(response.data.report);
//             setSelectedEntries(response.data.report.summary.detailedEntries.filter(e => e.status === 'Matched'));

//             setReportGenerated(true);
//         } catch (err) {
//             setError(err.response?.data?.message || 'Failed to generate report');
//         } finally {
//             setIsGenerating(false);
//         }
//     };

//     const generatePDF = async () => {
//         setIsGeneratingPDF(true);
//         try {
//             // PDF generation logic
//             alert("PDF generation would happen here in real implementation");
//         } catch (err) {
//             setError('Failed to generate PDF');
//         } finally {
//             setIsGeneratingPDF(false);
//         }
//     };

//     return (
//         <div>
//             <h2 className="text-xl font-semibold mb-4">Step 3: Processing Complete</h2>

//             {success && (
//                 <div className="mb-6 p-4 bg-green-100 text-green-700 rounded-md">
//                     {success}
//                 </div>
//             )}

//             {!reportGenerated ? (
//                 <div className="bg-gray-50 p-4 rounded-md mb-6">
//                     <h3 className="font-medium mb-4">Generate Settlement Report</h3>

//                     <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
//                         <div>
//                             <label className="block text-sm font-medium text-gray-700 mb-1">From Date</label>
//                             <input
//                                 type="date"
//                                 value={fromDate}
//                                 onChange={(e) => setFromDate(e.target.value)}
//                                 className="w-full p-2 border rounded-md"
//                             />
//                         </div>

//                         <div>
//                             <label className="block text-sm font-medium text-gray-700 mb-1">To Date</label>
//                             <input
//                                 type="date"
//                                 value={toDate}
//                                 onChange={(e) => setToDate(e.target.value)}
//                                 className="w-full p-2 border rounded-md"
//                             />
//                         </div>

//                         <div>
//                             <label className="block text-sm font-medium text-gray-700 mb-1">Report Type</label>
//                             <select
//                                 value={reportType}
//                                 onChange={(e) => setReportType(e.target.value)}
//                                 className="w-full p-2 border rounded-md"
//                             >
//                                 <option value="all">All Services</option>
//                                 <option value="taxi">Taxi Services</option>
//                                 <option value="theater">Theater Services</option>
//                             </select>
//                         </div>
//                     </div>

//                     <div className="flex justify-end">
//                         <button
//                             onClick={generateReport}
//                             disabled={isGenerating}
//                             className={`px-4 py-2 rounded-md text-white ${isGenerating ? 'bg-blue-400' : 'bg-blue-600 hover:bg-blue-700'}`}
//                         >
//                             {isGenerating ? 'Generating Report...' : 'Generate Report'}
//                         </button>
//                     </div>

//                     {error && (
//                         <div className="mt-4 p-3 bg-red-100 text-red-700 rounded-md">
//                             {error}
//                         </div>
//                     )}
//                 </div>
//             ) : (
//                 <div className="mb-6 space-y-6">
//                     {/* Report Header */}
//                     <div className="bg-white p-4 rounded-lg shadow-sm border">
//                         <h3 className="text-xl font-semibold mb-2">Settlement Report</h3>
//                         <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//                             <div>
//                                 <p className="text-sm text-gray-500">Report ID</p>
//                                 <p className="font-medium">{localReportData._id}</p>
//                             </div>
//                             <div>
//                                 <p className="text-sm text-gray-500">Generated At</p>
//                                 <p className="font-medium">
//                                     {new Date(localReportData.generatedAt).toLocaleString()}
//                                 </p>
//                             </div>
//                             <div>
//                                 <p className="text-sm text-gray-500">Report Type</p>
//                                 <p className="font-medium capitalize">{localReportData.reportType}</p>
//                             </div>
//                         </div>
//                     </div>

//                     {/* Period Information */}
//                     <div className="bg-white p-4 rounded-lg shadow-sm border">
//                         <h4 className="font-semibold mb-3">Report Period</h4>
//                         <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                             <div>
//                                 <p className="text-sm text-gray-500">Start Date</p>
//                                 <p className="font-medium">
//                                     {new Date(localReportData.periodStart).toLocaleDateString()}
//                                 </p>
//                             </div>
//                             <div>
//                                 <p className="text-sm text-gray-500">End Date</p>
//                                 <p className="font-medium">
//                                     {new Date(localReportData.periodEnd).toLocaleDateString()}
//                                 </p>
//                             </div>
//                         </div>
//                     </div>

//                     {/* Summary Statistics */}





//                     <div className="bg-white p-4 rounded-lg shadow-sm border">
//                         <h4 className="font-semibold mb-3">Financial Summary</h4>

//                         {/* Top Row - Transaction Overview */}
//                         <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
//                             <div className="border p-3 rounded-lg bg-blue-50">
//                                 <h5 className="font-medium mb-2 text-blue-800">All Transactions</h5>
//                                 <div className="space-y-1">
//                                     <p className="flex justify-between">
//                                         <span>Total Transactions:</span>
//                                         <span>{localReportData.summary.detailedEntries.length}</span>
//                                     </p>
//                                     <p className="flex justify-between">
//                                         <span>Total Collections:</span>
//                                         <span>₹{localReportData.summary.totalCollections.toFixed(2)}</span>
//                                     </p>
//                                 </div>
//                             </div>

//                             <div className="border p-3 rounded-lg bg-green-50">
//                                 <h5 className="font-medium mb-2 text-green-800">Matched (Payable)</h5>
//                                 <div className="space-y-1">
//                                     <p className="flex justify-between">
//                                         <span>Matched Transactions:</span>
//                                         <span>{matchedTotals.count}</span>
//                                     </p>
//                                     <p className="flex justify-between">
//                                         <span>Total Amount (Matched):</span>
//                                         <span>₹{matchedTotals.totalCollections.toFixed(2)}</span>
//                                     </p>
//                                     <p className="flex justify-between">
//                                         <span>Payable Amount:</span>
//                                         <span>₹{matchedTotals.totalPayable.toFixed(2)}</span>
//                                     </p>
//                                     <p className="flex justify-between">
//                                         <span>Platform Earnings:</span>
//                                         <span>₹{matchedTotals.platformEarnings.toFixed(2)}</span>
//                                     </p>
//                                 </div>
//                             </div>
//                         </div>

//                         {/* Bottom Row - Financial Details */}
//                         <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//                             {/* Gateway Charges */}
//                             <div className="border p-3 rounded-lg">
//                                 <p className="text-sm text-gray-500">Gateway Charges</p>
//                                 <div className="mt-2 space-y-1">
//                                     <p className="flex justify-between text-sm">
//                                         <span>All Transactions:</span>
//                                         <span>₹{localReportData.summary.totalGatewayCharges.toFixed(2)}</span>
//                                     </p>
//                                     <p className="flex justify-between font-medium">
//                                         <span className="text-green-600">Matched Only:</span>
//                                         <span className="text-green-600">₹{matchedTotals.gatewayCharges.toFixed(2)}</span>
//                                     </p>
//                                 </div>
//                             </div>

//                             {/* Taxes */}
//                             <div className="border p-3 rounded-lg">
//                                 <p className="text-sm text-gray-500">Taxes</p>
//                                 <div className="mt-2 space-y-1">
//                                     <p className="flex justify-between text-sm">
//                                         <span>All Transactions:</span>
//                                         <span>₹{localReportData.summary.totalTaxes.toFixed(2)}</span>
//                                     </p>
//                                     <p className="flex justify-between font-medium">
//                                         <span className="text-green-600">Matched Only:</span>
//                                         <span className="text-green-600">₹{matchedTotals.taxes.toFixed(2)}</span>
//                                     </p>
//                                 </div>
//                             </div>

//                             {/* Net Payable */}
//                             <div className="border p-3 rounded-lg">
//                                 <p className="text-sm text-gray-500">Net Payable to Platform</p>
//                                 <div className="mt-2 space-y-1">
//                                     <p className="flex justify-between text-sm">
//                                         <span>All Transactions:</span>
//                                         <span>₹{(localReportData.summary.totalPlatformEarnings - localReportData.summary.totalGatewayCharges).toFixed(2)}</span>
//                                     </p>
//                                     <p className="flex justify-between font-medium">
//                                         <span className="text-green-600">Matched Only:</span>
//                                         <span className="text-green-600">
//                                             ₹{(matchedTotals.platformEarnings - matchedTotals.gatewayCharges).toFixed(2)}
//                                         </span>
//                                     </p>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     {/* Transaction Filter Toggle */}
//                     {/* <div className="flex justify-end">
//               <label className="inline-flex items-center cursor-pointer">
//                 <span className="mr-3 text-sm font-medium text-gray-700">
//                   Show matched only
//                 </span>
//                 <div className="relative">
//                   <input
//                     type="checkbox"
//                     className="sr-only peer"
//                     checked={showMatchedOnly}
//                     onChange={() => setShowMatchedOnly(!showMatchedOnly)}
//                   />
//                   <div className="w-11 h-6 bg-gray-200 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
//                 </div>
//               </label>
//             </div> */}






//                     {/* Service-wise Breakdown */}
//                     {/* Service-wise Breakdown */}
//                     <div className="bg-white p-4 rounded-lg shadow-sm border">
//                         <h4 className="font-semibold mb-3">Service Breakdown</h4>
//                         <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                             {/* Theater Service */}
//                             <div className="border p-3 rounded-lg">
//                                 <h5 className="font-medium mb-2">Theater Services</h5>
//                                 <div className="space-y-2">
//                                     {/* All Transactions */}
//                                     <div className="pb-2 border-b">
//                                         <p className="text-sm text-gray-500">All Transactions</p>
//                                         <p className="flex justify-between">
//                                             <span>Total Transactions:</span>
//                                             <span>{localReportData.summary.serviceWiseBreakdown.theater.count}</span>
//                                         </p>
//                                         <p className="flex justify-between">
//                                             <span>Total Amount:</span>
//                                             <span>₹{localReportData.summary.serviceWiseBreakdown.theater.totalAmount.toFixed(2)}</span>
//                                         </p>
//                                     </div>

//                                     {/* Matched Only */}
//                                     <div className="pt-2">
//                                         <p className="text-sm text-green-600">Matched (Payable)</p>
//                                         <p className="flex justify-between">
//                                             <span>Matched Count:</span>
//                                             <span className="text-green-600">
//                                                 {localReportData.summary.detailedEntries.filter(e =>
//                                                     e.serviceType === 'theater' && e.status === 'Matched'
//                                                 ).length}
//                                             </span>
//                                         </p>
//                                         <p className="flex justify-between">
//                                             <span>Payable Amount:</span>
//                                             <span className="font-semibold text-green-600">
//                                                 ₹{localReportData.summary.detailedEntries
//                                                     .filter(e => e.serviceType === 'theater' && e.status === 'Matched')
//                                                     .reduce((sum, e) => sum + e.payableToPartner, 0)
//                                                     .toFixed(2)}
//                                             </span>
//                                         </p>
//                                         <p className="flex justify-between">
//                                             <span>Platform Earnings:</span>
//                                             <span>
//                                                 ₹{localReportData.summary.detailedEntries
//                                                     .filter(e => e.serviceType === 'theater' && e.status === 'Matched')
//                                                     .reduce((sum, e) => sum + e.platformEarnings, 0)
//                                                     .toFixed(2)}
//                                             </span>
//                                         </p>
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* Taxi Service */}
//                             <div className="border p-3 rounded-lg">
//                                 <h5 className="font-medium mb-2">Taxi Services</h5>
//                                 <div className="space-y-2">
//                                     {/* All Transactions */}
//                                     <div className="pb-2 border-b">
//                                         <p className="text-sm text-gray-500">All Transactions</p>
//                                         <p className="flex justify-between">
//                                             <span>Total Transactions:</span>
//                                             <span>{localReportData.summary.serviceWiseBreakdown.taxi.count}</span>
//                                         </p>
//                                         <p className="flex justify-between">
//                                             <span>Total Amount:</span>
//                                             <span>₹{localReportData.summary.serviceWiseBreakdown.taxi.totalAmount.toFixed(2)}</span>
//                                         </p>
//                                     </div>

//                                     {/* Matched Only */}
//                                     <div className="pt-2">
//                                         <p className="text-sm text-green-600">Matched (Payable)</p>
//                                         <p className="flex justify-between">
//                                             <span>Matched Count:</span>
//                                             <span className="text-green-600">
//                                                 {localReportData.summary.detailedEntries.filter(e =>
//                                                     e.serviceType === 'taxi' && e.status === 'Matched'
//                                                 ).length}
//                                             </span>
//                                         </p>
//                                         <p className="flex justify-between">
//                                             <span>Payable Amount:</span>
//                                             <span className="font-semibold text-green-600">
//                                                 ₹{localReportData.summary.detailedEntries
//                                                     .filter(e => e.serviceType === 'taxi' && e.status === 'Matched')
//                                                     .reduce((sum, e) => sum + e.payableToPartner, 0)
//                                                     .toFixed(2)}
//                                             </span>
//                                         </p>
//                                         <p className="flex justify-between">
//                                             <span>Platform Earnings:</span>
//                                             <span>
//                                                 ₹{localReportData.summary.detailedEntries
//                                                     .filter(e => e.serviceType === 'taxi' && e.status === 'Matched')
//                                                     .reduce((sum, e) => sum + e.platformEarnings, 0)
//                                                     .toFixed(2)}
//                                             </span>
//                                         </p>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     {/* Detailed Transactions */}
//                     {/* <div className="bg-white p-4 rounded-lg shadow-sm border">
//               <div className="flex justify-between items-center mb-3">
//                 <h4 className="font-semibold">Detailed Transactions</h4>
//                 <span className="text-sm text-gray-500">
//                   {localReportData.summary.detailedEntries.length} transactions
//                 </span>
//               </div>

//               <div className="overflow-x-auto">
//                 <table className="min-w-full divide-y divide-gray-200">
//                   <thead className="bg-gray-50">
//                     <tr>
//                       <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Service</th>
//                       <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Transaction</th>
//                       <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Amount</th>
//                       <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Payable</th>
//                       <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Earnings</th>
//                       <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Taxes</th>
//                       <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
//                     </tr>
//                   </thead>
//                   <tbody className="bg-white divide-y divide-gray-200">
//                     {localReportData.summary.detailedEntries.map((entry, index) => (
//                       <tr key={index} className="hover:bg-gray-50">
//                         <td className="px-4 py-3 whitespace-nowrap">
//                           <span className={`px-2 py-1 text-xs rounded-full ${
//                             entry.serviceType === 'taxi' ? 'bg-blue-100 text-blue-800' : 'bg-purple-100 text-purple-800'
//                           }`}>
//                             {entry.serviceType}
//                           </span>
//                         </td>
//                         <td className="px-4 py-3 whitespace-nowrap">
//                           {entry.transactionId || 'N/A'}
//                         </td>
//                         <td className="px-4 py-3 whitespace-nowrap">
//                           ₹{entry.customerAmount.toFixed(2)}
//                         </td>
//                         <td className="px-4 py-3 whitespace-nowrap">
//                           ₹{entry.payableToPartner.toFixed(2)}
//                         </td>
//                         <td className="px-4 py-3 whitespace-nowrap">
//                           ₹{entry.platformEarnings.toFixed(2)}
//                         </td>
//                         <td className="px-4 py-3 whitespace-nowrap">
//                           ₹{entry.taxes.toFixed(2)}
//                         </td>
//                         <td className="px-4 py-3 whitespace-nowrap">
//                           <span className={`px-2 py-1 text-xs rounded-full ${
//                             entry.status === 'Matched' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'
//                           }`}>
//                             {entry.status}
//                           </span>
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div> */}


//                     {/* Detailed Transactions */}
//                     <div className="bg-white p-4 rounded-lg shadow-sm border">
//                         <div className="flex justify-between items-center mb-3">
//                             <h4 className="font-semibold">Detailed Transactions</h4>
//                             <span className="text-sm text-gray-500">
//                                 {localReportData.summary.detailedEntries.length} transactions
//                             </span>
//                         </div>

//                         <div className="overflow-x-auto">
//                             <table className="min-w-full divide-y divide-gray-200">
//                                 <thead className="bg-gray-50">
//                                     <tr>
//                                         <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Select</th>
//                                         <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Service</th>
//                                         <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Invoice</th>
//                                         <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Transaction</th>
//                                         <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Amount</th>
//                                         <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Total Payable</th>
//                                         <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Base Amount</th>
//                                         <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Taxes on Base Amount</th>
//                                         <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Gateway Charges</th>
//                                         <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Platform Fee Collection</th>
//                                         <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Platform Tax</th>
//                                         <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
//                                         <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Bank Details</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody className="bg-white divide-y divide-gray-200">
//                                     {localReportData.summary.detailedEntries.map((entry, index) => (
//                                         <tr key={index} className="hover:bg-gray-50">

//                                             <td>
//                                                 <input
//                                                     type="checkbox"
//                                                     checked={selectedEntries.some(e => e.transactionId === entry.transactionId)}
//                                                     onChange={() => {
//                                                         if (selectedEntries.some(e => e.transactionId === entry.transactionId)) {
//                                                             setSelectedEntries(selectedEntries.filter(e => e.transactionId !== entry.transactionId));
//                                                         } else {
//                                                             setSelectedEntries([...selectedEntries, entry]);
//                                                         }
//                                                     }}
//                                                 />
//                                             </td>


//                                             <td className="px-4 py-3 whitespace-nowrap">
//                                                 <span className={`px-2 py-1 text-xs rounded-full ${entry.serviceType === 'taxi' ? 'bg-blue-100 text-blue-800' : 'bg-purple-100 text-purple-800'
//                                                     }`}>
//                                                     {entry.serviceType}
//                                                 </span>
//                                             </td>


//                                             <td className="px-4 py-3 whitespace-nowrap">
//                                                 {entry.invoiceNumber || 'N/A'}
//                                             </td>
//                                             <td className="px-4 py-3 whitespace-nowrap">
//                                                 {entry.transactionId || 'N/A'}
//                                             </td>
//                                             <td className="px-4 py-3 whitespace-nowrap">
//                                                 ₹{entry?.customerAmount?.toFixed(2)}
//                                             </td>
//                                             <td className="px-4 py-3 whitespace-nowrap">
//                                                 ₹{entry?.payableToPartner?.toFixed(2)}
//                                             </td>
//                                             <td className="px-4 py-3 whitespace-nowrap">
//                                                 ₹{entry?.baseAmount?.toFixed(2)}
//                                             </td>
//                                             <td className="px-4 py-3 whitespace-nowrap">
//                                                 ₹{entry?.taxes?.toFixed(2)}
//                                             </td>
//                                             <td className="px-4 py-3 whitespace-nowrap">
//                                                 ₹{entry?.gatewayCharges?.toFixed(2)}
//                                             </td>
//                                             <td className="px-4 py-3 whitespace-nowrap">
//                                                 ₹{entry?.platformEarnings?.toFixed(2)}
//                                             </td>
//                                             <td className="px-4 py-3 whitespace-nowrap">
//                                                 ₹{entry?.platformTax?.toFixed(2)}
//                                             </td>

//                                             <td className="px-4 py-3 whitespace-nowrap">
//                                                 <span className={`px-2 py-1 text-xs rounded-full ${entry.status === 'Matched' ? 'bg-green-100 text-green-800' :
//                                                     entry.status === 'NA' ? 'bg-gray-100 text-gray-800' : 'bg-yellow-100 text-yellow-800'
//                                                     }`}>
//                                                     {entry?.status}
//                                                 </span>
//                                             </td>
//                                             <td className="px-4 py-3 whitespace-nowrap">
//                                                 {entry.serviceType === 'taxi' && entry.riderBankDetails ? (
//                                                     <div className="text-xs">
//                                                         <p><strong>Bank:</strong> {entry.riderBankDetails.bankName}</p>
//                                                         <p><strong>Account:</strong> {entry.riderBankDetails.accountNumber}</p>
//                                                         <p><strong>IFSC:</strong> {entry.riderBankDetails.IFSC}</p>
//                                                     </div>
//                                                 ) : entry.serviceType === 'theater' && entry.theaterBankDetails ? (
//                                                     <div className="text-xs">
//                                                         <p><strong>Bank:</strong> {entry.theaterBankDetails.bankName}</p>
//                                                         <p><strong>Account:</strong> {entry.theaterBankDetails.accountNumber}</p>
//                                                         <p><strong>IFSC:</strong> {entry.theaterBankDetails.ifscCode}</p>
//                                                     </div>
//                                                 ) : 'N/A'}
//                                             </td>
//                                         </tr>
//                                     ))}
//                                 </tbody>
//                             </table>
//                         </div>
//                     </div>

//                     {/* Action Buttons */}
//                     <div className="flex justify-between">
//                         <div>
//                             <button
//                                 onClick={generatePDF}
//                                 disabled={isGeneratingPDF}
//                                 className={`px-4 py-2 rounded-md text-white flex items-center ${isGeneratingPDF ? 'bg-gray-400' : 'bg-green-600 hover:bg-green-700'
//                                     }`}
//                             >
//                                 {isGeneratingPDF ? (
//                                     <>
//                                         <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
//                                             <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//                                             <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
//                                         </svg>
//                                         Generating PDF...
//                                     </>
//                                 ) : (
//                                     <>
//                                         <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
//                                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10"></path>
//                                         </svg>
//                                         Download PDF Report
//                                     </>
//                                 )}
//                             </button>
//                         </div>
//                         <div>
//                             <button
//                                 onClick={() => setReportGenerated(false)}
//                                 className="px-4 py-2 bg-gray-300 text-gray-800 rounded-md hover:bg-gray-400 mr-4"
//                             >
//                                 Regenerate Report
//                             </button>
//                             <button
//                                 onClick={nextStep}
//                                 className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
//                             >
//                                 Next: Select Bank for Payout
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default Step3;









import React, { useState, useEffect } from 'react';
import axios from 'axios';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { format, parse } from 'date-fns';
import env from "../../env.json";


// const Step3 = ({ success, nextStep, setReportData, selectedEntries, setSelectedEntries }) => {


const Step3 = ({
    success,
    nextStep,
    selectedEntries,
    setSelectedEntries,
    reportData,
    setReportData,
    fromDate,
    setFromDate,
    toDate,
    setToDate,
    reportType,
    setReportType,
    reportGenerated,
    setReportGenerated
}) => {
    const [isGenerating, setIsGenerating] = useState(false);
    const [localReportData, setLocalReportData] = useState(reportData); // sync if needed

    // const [isGenerating, setIsGenerating] = useState(false);
    // const [localReportData, setLocalReportData] = useState(null);

    // const [fromDate, setFromDate] = useState('');
    // const [toDate, setToDate] = useState('');
    // const [reportType, setReportType] = useState('all');

    // const [reportGenerated, setReportGenerated] = useState(false);

    const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);
    const [error, setError] = useState('');


    const [showMatchedOnly, setShowMatchedOnly] = useState(false);
    const [showSelectedOnly, setShowSelectedOnly] = useState(false);
    const [showUnselectedMatched, setShowUnselectedMatched] = useState(false);
    const [showUnselected, setShowUnselected] = useState(false);




    const { BASE_URL } = env;



    // useEffect(() => {
    //     if (reportData && !localReportData) {
    //       setLocalReportData(reportData);
    //     }
    //   }, [reportData]);


    useEffect(() => {
        if (reportData && !localReportData) {
            setLocalReportData(reportData);
            setReportGenerated(true); // <-- this ensures the UI is ready
        }
    }, [reportData]);





    // Format as DD/MM/YYYY for display
    const formatDisplayDate = (date) => (date ? format(date, 'dd/MM/yyyy') : '');

    // Filter transactions based on toggles
    const filteredEntries = showSelectedOnly
        ? localReportData?.summary?.detailedEntries.filter(entry =>
            selectedEntries.some(e => e.transactionId === entry.transactionId))
        : showMatchedOnly
            ? localReportData?.summary?.detailedEntries.filter(entry => entry.status === 'Matched')
            : localReportData?.summary?.detailedEntries;

    // Calculate matched-only totals
    const matchedTotals = localReportData?.summary?.detailedEntries
        ?.filter(entry => entry.status === 'Matched' || entry.status === 'NA')
        ?.reduce((acc, entry) => ({
            totalCollections: acc.totalCollections + entry.customerAmount,
            totalPayable: acc.totalPayable + entry.payableToPartner,
            platformEarnings: acc.platformEarnings + entry.platformEarnings,
            gatewayCharges: acc.gatewayCharges + entry.gatewayCharges,
            taxes: acc.taxes + entry.taxes,
            count: acc.count + 1
        }), {
            totalCollections: 0,
            totalPayable: 0,
            platformEarnings: 0,
            gatewayCharges: 0,
            taxes: 0,
            count: 0
        }) || {
        totalCollections: 0,
        totalPayable: 0,
        platformEarnings: 0,
        gatewayCharges: 0,
        taxes: 0,
        count: 0
    };

    // Calculate selected-only totals
    const selectedTotals = selectedEntries.reduce((acc, entry) => ({
        totalCollections: acc.totalCollections + entry.customerAmount,
        totalPayable: acc.totalPayable + entry.payableToPartner,
        platformEarnings: acc.platformEarnings + entry.platformEarnings,
        gatewayCharges: acc.gatewayCharges + entry.gatewayCharges,
        taxes: acc.taxes + entry.taxes,
        count: acc.count + 1
    }), {
        totalCollections: 0,
        totalPayable: 0,
        platformEarnings: 0,
        gatewayCharges: 0,
        taxes: 0,
        count: 0
    });

    const generateReport = async () => {
        if (!fromDate || !toDate) {
            setError('Please select both date ranges');
            return;
        }

        setIsGenerating(true);
        setError('');





        try {
            const response = await axios.post(`${BASE_URL}/generateReport`, {
            // const response = await axios.post('http://localhost:8080/generateReport', {
                // const response = await axios.post('https://admin-api.cruze.asia/generateReport', {
                // fromDate,

                // toDate,
                // reportType

                fromDate: fromDate ? format(fromDate, 'yyyy-MM-dd') : '',
                toDate: toDate ? format(toDate, 'yyyy-MM-dd') : '',
                reportType: reportType,
            });

            console.log('response.data.report', response.data.report);

            setReportData(response.data.report);
            setLocalReportData(response.data.report);
            // setSelectedEntries(response.data.report.summary.detailedEntries.filter(
            //     e => e.status === 'Matched' || e.status === 'NA'
            // ));
            setSelectedEntries(response.data.report.summary.detailedEntries.filter(
                e => ['Matched', 'NA', 'Refunded'].includes(e.status)
            ));

            setReportGenerated(true);
        } catch (err) {
            setError(err.response?.data?.message || 'Failed to generate report');
        } finally {
            setIsGenerating(false);
        }
    };

    const generatePDF = () => {
        setIsGeneratingPDF(true);
        try {
            // Use landscape to accommodate extra columns without overlap
            const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });

            // Title
            doc.setFontSize(16);
            doc.text('Settlement Report', 14, 20);

            // Meta Info
            doc.setFontSize(11);
            doc.text(`Report ID: ${localReportData._id}`, 14, 30);
            doc.text(`Generated At: ${new Date(localReportData.generatedAt).toLocaleString()}`, 14, 36);
            doc.text(`Period: ${localReportData.periodStart} to ${localReportData.periodEnd}`, 14, 42);
            doc.text(`Report Type: ${localReportData.reportType}`, 14, 48);

            // Table headers and data
            const headers = [[
                'Service',
                'Invoice',
                'Movie',
                'Show Date',
                'Transaction',
                'Amount',
                'Payable',
                'Base',
                'Taxes',
                'Gateway',
                'Fee',
                'Platform Tax',
                'Status'
            ]];

            const data = [...filteredEntries]
                .sort((a, b) => {
                    const invA = a.invoiceNumber || '';
                    const invB = b.invoiceNumber || '';
                    return invA.localeCompare(invB, undefined, { numeric: true });
                })
                .map((entry) => [
                    entry.serviceType,
                    entry.invoiceNumber || 'N/A',
                    entry.movieName || 'N/A',
                    (entry.showDate ? new Date(entry.showDate).toLocaleDateString('en-IN') : 'N/A'),
                    entry.transactionId || 'N/A',
                    `Rs.${(entry.customerAmount ?? 0).toFixed(2)}`,
                    `Rs.${(entry.payableToPartner ?? 0).toFixed(2)}`,
                    `Rs.${(entry.baseAmount ?? 0).toFixed(2)}`,
                    `Rs.${(entry.taxes ?? 0).toFixed(2)}`,
                    `Rs.${(entry.gatewayCharges ?? 0).toFixed(2)}`,
                    `Rs.${(entry.platformEarnings ?? 0).toFixed(2)}`,
                    `Rs.${(entry.platformTax ?? 0).toFixed(2)}`,
                    entry.status
                ]);








            // filteredEntries.map(entry => ([
            //     entry.serviceType,
            //     entry.invoiceNumber || 'N/A',
            //     entry.transactionId || 'N/A',
            //     `Rs.${entry.customerAmount.toFixed(2)}`,
            //     `Rs.${entry.payableToPartner.toFixed(2)}`,
            //     `Rs.${entry.baseAmount?.toFixed(2) || '0.00'}`,
            //     `Rs.${entry.taxes.toFixed(2)}`,
            //     `Rs.${entry.gatewayCharges.toFixed(2)}`,
            //     `Rs.${entry.platformEarnings.toFixed(2)}`,
            //     `Rs.${entry.platformTax?.toFixed(2) || '0.00'}`,
            //     entry.status
            // ]));

            autoTable(doc, {
                head: headers,
                body: data,
                startY: 55,
                theme: 'grid',
                styles: {
                    fontSize: 7,
                    overflow: 'lineBreak',
                    cellPadding: 1.5,
                    lineWidth: 0.1,
                    lineColor: [200, 200, 200]
                },
                tableLineColor: [160, 160, 160],
                tableLineWidth: 0.2,
                columnStyles: {
                    2: { cellWidth: 36 }, // Movie
                    3: { cellWidth: 24 }, // Show Date
                    4: { cellWidth: 50 }  // Transaction
                },
                headStyles: {
                    fillColor: [22, 160, 133],
                    textColor: [255, 255, 255]
                },
                alternateRowStyles: {
                    fillColor: [245, 245, 245]
                },
                didParseCell: (data) => {
                    if ([0, 1, 2, 3, 12].includes(data.column.index)) {
                        data.cell.styles.halign = 'left';
                    } else {
                        data.cell.styles.halign = 'right';
                    }
                }
            });

            doc.save(`Settlement_Report_${new Date().toISOString().slice(0, 10)}.pdf`);
        } catch (err) {
            console.error('PDF generation error:', err);
            setError('Failed to generate PDF');
        } finally {
            setIsGeneratingPDF(false);
        }
    };




    const handleDateChange = (setter) => (e) => {
        const input = e.target.value;
        const isValid = /^\d{2}\/\d{2}\/\d{4}$/.test(input); // Simple validation: DD/MM/YYYY

        if (input === '' || isValid) {
            setter(input);
        }
    };





    function formatDateUTC(dateStr) {
        const d = new Date(dateStr);
        return d.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            timeZone: "UTC", // prevents shifting to IST
        });
    }


    return (
        <div>
            <h2 className="text-xl font-semibold mb-4">Step 2: Processing Complete</h2>

            {/* {success && (
                <div className="mb-6 p-4 bg-green-100 text-green-700 rounded-md">
                    {success}
                </div>
            )} */}

            {!reportGenerated ? (
                <div className="bg-gray-50 p-4 rounded-md mb-6">
                    <h4 className="font-medium mb-4">Generate Settlement Report</h4>

                    {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">From Date</label>
                            <input
                                type="date"
                                value={fromDate}
                                onChange={(e) => setFromDate(e.target.value)}
                                className="w-full p-2 border rounded-md"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">To Date</label>
                            <input
                                type="date"
                                value={toDate}
                                onChange={(e) => setToDate(e.target.value)}
                                className="w-full p-2 border rounded-md"
                            />
                        </div>


                        <div>

                            <label className="block text-sm font-medium text-gray-700 mb-1">From Date</label>
                            <DatePicker
                                selected={fromDate}
                                onChange={(date) => setFromDate(date)}
                                dateFormat="dd/MM/yyyy"
                                className="w-full p-2 border rounded-md"
                                placeholderText="Select date"
                            />

                            <label className="block text-sm font-medium text-gray-700 mb-1">To Date</label>
                            <DatePicker
                                selected={toDate}
                                onChange={(date) => setToDate(date)}
                                dateFormat="dd/MM/yyyy"
                                className="w-full p-2 border rounded-md"
                                placeholderText="Select date"
                                minDate={fromDate} // Optional: prevent selecting "to date" before "from date"
                            />
                        </div>








                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Report Type</label>
                            <select
                                value={reportType}
                                onChange={(e) => setReportType(e.target.value)}
                                className="w-full p-2 border rounded-md"
                            >
                                <option value="all">All Services</option>
                                <option value="taxi">Taxi Services</option>
                                <option value="theater">Theater Services</option>
                            </select>
                        </div>
                    </div> */}








                    {/* uisng the date picker for the format  */}

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4 items-end">
                        {/* From Date */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">From Date</label>
                            <DatePicker
                                selected={fromDate}
                                onChange={(date) => setFromDate(date)}
                                dateFormat="dd/MM/yyyy"
                                className="w-full p-2 border rounded-md"
                                placeholderText="Select date"
                            />
                        </div>

                        {/* To Date */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">To Date</label>
                            <DatePicker
                                selected={toDate}
                                onChange={(date) => setToDate(date)}
                                dateFormat="dd/MM/yyyy"
                                className="w-full p-2 border rounded-md"
                                placeholderText="Select date"
                                minDate={fromDate}
                            />
                        </div>

                        {/* Report Type */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Report Type</label>
                            <select
                                value={reportType}
                                onChange={(e) => setReportType(e.target.value)}
                                className="w-full p-2 border rounded-md"
                            >
                                <option value="all">All Services</option>
                                <option value="taxi">Taxi Services</option>
                                <option value="theater">Theater Services</option>
                            </select>
                        </div>
                    </div>



                    <div className="flex justify-end">
                        <button
                            onClick={generateReport}
                            disabled={isGenerating}
                            className={`px-4 py-2 rounded-md text-white ${isGenerating ? 'bg-blue-400' : 'bg-blue-600 hover:bg-blue-700'}`}
                        >
                            {isGenerating ? 'Generating Report...' : 'Generate Report'}
                        </button>
                    </div>

                    {error && (
                        <div className="mt-4 p-3 bg-red-100 text-red-700 rounded-md">
                            {error}
                        </div>
                    )}
                </div>
            ) : (
                <div className="mb-6 space-y-6">




                    {/* Action Buttons */}
                    <div className="flex justify-between">
                        <div>
                            <button
                                onClick={generatePDF}
                                disabled={isGeneratingPDF}
                                className={`px-4 py-2 rounded-md text-white flex items-center ${isGeneratingPDF ? 'bg-gray-400' : 'bg-green-600 hover:bg-green-700'}`}
                            >
                                {isGeneratingPDF ? (
                                    <>
                                        <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                        </svg>
                                        Generating PDF...
                                    </>
                                ) : (
                                    <>
                                        <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10"></path>
                                        </svg>
                                        Download PDF Report
                                    </>
                                )}
                            </button>
                        </div>
                        <div>
                            <button
                                onClick={() => setReportGenerated(false)}
                                className="px-4 py-2 bg-gray-300 text-gray-800 rounded-md hover:bg-gray-400 mr-4"
                            >
                                Regenerate Report
                            </button>
                            <button
                                onClick={nextStep}
                                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                            >
                                Next: Select Bank for Payout
                            </button>
                        </div>
                    </div>





                    {/* Report Header */}
                    <div className="bg-white p-4 rounded-lg shadow-sm border">
                        <h3 className="text-xl font-semibold mb-2">Settlement Report</h3>
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                            <div>
                                <p className="text-sm text-gray-500">Report ID</p>
                                <p className="font-medium">{localReportData._id}</p>
                            </div>
                            <div>
                                <p className="text-sm text-gray-500">Generated At</p>
                                <p className="font-medium">
                                    {new Date(localReportData.generatedAt).toLocaleString()}
                                </p>
                            </div>
                            <div>
                                <p className="text-sm text-gray-500">Report Type</p>
                                <p className="font-medium capitalize">{localReportData.reportType}</p>
                            </div>
                        </div>
                    </div>

                    {/* Period Information */}
                    <div className="bg-white p-4 rounded-lg shadow-sm border">
                        <h4 className="font-semibold mb-3">Report Period</h4>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                                <p className="text-sm text-gray-500">Start Date</p>
                                <p className="font-medium">
                                    {/* {new Date(localReportData.periodStart).toLocaleDateString()} */}
                                    {/* {format(new Date(localReportData.periodStart), 'dd/MM/yyyy')} */}
                                    {formatDateUTC(localReportData.periodStart)}
                                </p>
                            </div>
                            <div>
                                <p className="text-sm text-gray-500">End Date</p>
                                <p className="font-medium">
                                    {/* {new Date(localReportData.periodEnd).toLocaleDateString()} */}
                                    {/* {format(new Date(localReportData.periodEnd), 'dd/MM/yyyy')} */}
                                    {formatDateUTC(localReportData.periodEnd)}
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Selection Summary */}
                    <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-6">
                        <div className="flex items-center">
                            <div className="flex-shrink-0">
                                <svg className="h-5 w-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                                </svg>
                            </div>
                            <div className="ml-3">
                                <h3 className="text-sm font-medium text-yellow-800">Selection Summary</h3>
                                <div className="flex flex-col items-start text-sm text-gray-700 space-y-1">
                                    <span className="font-medium text-gray-600">Matched Transactions</span>
                                    <div className="flex items-center space-x-1">
                                        <span className="px-2 py-0.5 rounded bg-green-100 text-green-700 font-semibold">
                                            {selectedEntries.filter(e => e.status === 'Matched').length} selected
                                        </span>
                                        <span className="text-xs text-gray-500">
                                            / {localReportData?.summary?.detailedEntries.filter(e => e.status === 'Matched').length} total
                                        </span>
                                    </div>
                                </div>

                                <div className="flex flex-col items-start text-sm text-gray-700 space-y-1 mt-2">
                                    <span className="font-medium text-gray-600">Cash Transactions</span>
                                    <div className="flex items-center space-x-1">
                                        <span className="px-2 py-0.5 rounded bg-blue-100 text-blue-700 font-semibold">
                                            {selectedEntries.filter(e => e.status === 'NA').length} selected
                                        </span>
                                        <span className="text-xs text-gray-500">
                                            / {localReportData?.summary?.detailedEntries.filter(e => e.status === 'NA').length} total
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Summary Statistics */}
                    <div className="bg-white p-4 rounded-lg shadow-sm border">
                        <h4 className="font-semibold mb-3">Financial Summary</h4>

                        {/* Top Row - Transaction Overview */}
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                            <div className="border p-3 rounded-lg bg-blue-50">
                                <h5 className="font-medium mb-2 text-blue-800">All Transactions</h5>
                                <div className="space-y-1 text-sm">
                                    <p className="flex justify-between">
                                        <span>Total Transactions:</span>
                                        <span>{localReportData.summary.detailedEntries.length}</span>
                                    </p>
                                    <p className="flex justify-between">
                                        <span>Total Collections:</span>
                                        <span>₹{localReportData.summary.totalCollections.toFixed(2)}</span>
                                    </p>
                                </div>
                            </div>

                            <div className="border p-3 rounded-lg bg-green-50">
                                <h5 className="font-medium mb-2 text-green-800">Matched (Payable)</h5>
                                <div className="space-y-1">
                                    <div className="flex flex-col items-start text-sm text-gray-700 space-y-1">
                                        <span className="font-medium text-gray-600">Matched Transactions</span>
                                        <div className="flex items-center space-x-1">
                                            <span className="px-2 py-0.5 rounded bg-green-100 text-green-700 font-semibold">
                                                {selectedEntries.length} selected
                                            </span>
                                            <span className="text-xs text-gray-500">/ {matchedTotals.count} total</span>
                                        </div>
                                    </div>

                                    <div className="flex flex-col items-start text-sm text-gray-700 space-y-1">
                                        <span className="font-medium text-gray-600">Total Amount (Matched)</span>
                                        <div className="flex items-center space-x-1">
                                            <span className="px-2 py-0.5 rounded bg-blue-100 text-blue-700 font-semibold">
                                                ₹{selectedTotals.totalCollections.toFixed(2)} selected
                                            </span>
                                            <span className="text-xs text-gray-500">
                                                / ₹{matchedTotals.totalCollections.toFixed(2)} total
                                            </span>
                                        </div>
                                    </div>

                                    <div className="flex flex-col items-start text-sm text-gray-700 space-y-1 mt-2">
                                        <span className="font-medium text-gray-600">Payable Amount</span>
                                        <div className="flex items-center space-x-1">
                                            <span className="px-2 py-0.5 rounded bg-yellow-100 text-yellow-700 font-semibold">
                                                ₹{selectedTotals.totalPayable.toFixed(2)} selected
                                            </span>
                                            <span className="text-xs text-gray-500">
                                                / ₹{matchedTotals.totalPayable.toFixed(2)} total
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="border p-3 rounded-lg bg-purple-50">
                                <h5 className="font-medium mb-2 text-purple-800">Selection Impact</h5>
                                <div className="space-y-1 text-sm">
                                    <p className="flex justify-between">
                                        <span>Unselected Matched:</span>
                                        <span>{matchedTotals.count - selectedEntries.length}</span>
                                    </p>
                                    <p className="flex justify-between">
                                        <span>Amount Difference:</span>
                                        <span className="text-red-600">
                                            -₹{(matchedTotals.totalPayable - selectedTotals.totalPayable).toFixed(2)}
                                        </span>
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Bottom Row - Financial Details */}
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                            {/* Gateway Charges */}
                            <div className="border p-3 rounded-lg">
                                <p className="text-sm text-gray-500">Gateway Charges</p>
                                <div className="mt-2 space-y-1">
                                    <p className="flex justify-between text-sm">
                                        <span>All Transactions:</span>
                                        <span>₹{localReportData.summary.totalGatewayCharges.toFixed(2)}</span>
                                    </p>
                                    <p className="flex justify-between">
                                        <span className="text-green-600">Selected Only:</span>
                                        <span className="text-green-600">₹{selectedTotals.gatewayCharges.toFixed(2)}</span>
                                    </p>
                                </div>
                            </div>

                            {/* Taxes */}
                            <div className="border p-3 rounded-lg">
                                <p className="text-sm text-gray-500">Taxes(GST)</p>
                                <div className="mt-2 space-y-1">
                                    <p className="flex justify-between text-sm">
                                        <span>All Transactions:</span>
                                        <span>₹{localReportData.summary.totalTaxes.toFixed(2)}</span>
                                    </p>
                                    <p className="flex justify-between">
                                        <span className="text-green-600">Selected Only:</span>
                                        <span className="text-green-600">₹{selectedTotals.taxes.toFixed(2)}</span>
                                    </p>
                                </div>
                            </div>

                            {/* Net Payable */}
                            <div className="border p-3 rounded-lg">
                                <p className="text-sm text-gray-500">Payable(Payment)</p>
                                <div className="mt-2 space-y-1">
                                    <p className="flex justify-between text-sm">
                                        <span>All Transactions:</span>
                                        <span>₹{(localReportData.summary.totalPlatformEarnings - localReportData.summary.totalGatewayCharges).toFixed(2)}</span>
                                    </p>
                                    <p className="flex justify-between font-medium">
                                        <span className="text-green-600">Selected Only:</span>
                                        <span className="text-green-600">
                                            ₹{(selectedTotals.platformEarnings - selectedTotals.gatewayCharges).toFixed(2)}
                                        </span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Service-wise Breakdown */}
                    <div className="bg-white p-4 rounded-lg shadow-sm border">
                        <h4 className="font-semibold mb-3">Service Breakdown</h4>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            {/* Theater Service */}
                            <div className="border p-3 rounded-lg">
                                <h5 className="font-medium mb-2">Theater Services</h5>
                                <div className="space-y-2">
                                    <div className="pb-2 border-b">
                                        <p className="text-sm text-gray-500">All Transactions</p>
                                        <p className="flex justify-between">
                                            <span>Total Transactions:</span>
                                            <span>{localReportData.summary.serviceWiseBreakdown.theater.count}</span>
                                        </p>
                                        <p className="flex justify-between">
                                            <span>Total Amount:</span>
                                            <span>₹{localReportData.summary.serviceWiseBreakdown.theater.totalAmount.toFixed(2)}</span>
                                        </p>
                                    </div>
                                    <div className="pt-2">
                                        <p className="text-sm text-green-600">Matched (Payable)</p>
                                        <p className="flex justify-between">
                                            <span>Selected Count:</span>
                                            <span className="text-green-600">
                                                {selectedEntries.filter(e => e.serviceType === 'theater').length}
                                            </span>
                                        </p>
                                        <p className="flex justify-between">
                                            <span>Payable Amount:</span>
                                            <span className="font-semibold text-green-600">
                                                ₹{selectedEntries
                                                    .filter(e => e.serviceType === 'theater')
                                                    .reduce((sum, e) => sum + e.payableToPartner, 0)
                                                    .toFixed(2)}
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* Taxi Service */}
                            <div className="border p-3 rounded-lg">
                                <h5 className="font-medium mb-2">Taxi Services</h5>
                                <div className="space-y-2">
                                    <div className="pb-2 border-b">
                                        <p className="text-sm text-gray-500">All Transactions</p>
                                        <p className="flex justify-between">
                                            <span>Total Transactions:</span>
                                            <span>{localReportData.summary.serviceWiseBreakdown.taxi.count}</span>
                                        </p>
                                        <p className="flex justify-between">
                                            <span>Total Amount:</span>
                                            <span>₹{localReportData.summary.serviceWiseBreakdown.taxi.totalAmount.toFixed(2)}</span>
                                        </p>
                                    </div>
                                    <div className="pt-2">
                                        <p className="text-sm text-green-600">Matched (Payable)</p>
                                        <p className="flex justify-between">
                                            <span>Selected Count:</span>
                                            <span className="text-green-600">
                                                {selectedEntries.filter(e => e.serviceType === 'taxi').length}
                                            </span>
                                        </p>
                                        <p className="flex justify-between">
                                            <span>Payable Amount:</span>
                                            <span className="font-semibold text-green-600">
                                                ₹{selectedEntries
                                                    .filter(e => e.serviceType === 'taxi')
                                                    .reduce((sum, e) => sum + e.payableToPartner, 0)
                                                    .toFixed(2)}
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Transaction Filter Controls */}
                    <div className="flex justify-between items-center mb-4">
                        <div className="flex items-center space-x-4">
                            <label className="inline-flex items-center">
                                <input
                                    type="checkbox"
                                    className="form-checkbox"
                                    checked={showMatchedOnly}
                                    onChange={() => setShowMatchedOnly(!showMatchedOnly)}
                                />
                                <span className="ml-2">Show matched only</span>
                            </label>
                            <label className="inline-flex items-center">
                                <input
                                    type="checkbox"
                                    className="form-checkbox"
                                    checked={showSelectedOnly}
                                    onChange={() => setShowSelectedOnly(!showSelectedOnly)}
                                />
                                <span className="ml-2">Show selected only</span>
                            </label>
                            {showUnselectedMatched && (
                                <label className="inline-flex items-center">
                                    <input
                                        type="checkbox"
                                        className="form-checkbox"
                                        checked={showUnselectedMatched}
                                        onChange={() => setShowUnselectedMatched(!showUnselectedMatched)}
                                    />
                                    <span className="ml-2">Highlight unselected</span>
                                </label>
                            )}
                        </div>
                        <span className="text-sm text-gray-500">
                            Showing {filteredEntries?.length || 0} transactions
                        </span>
                    </div>





                    {/* Detailed Transactions */}
                    <div className="bg-white p-4 rounded-lg shadow-sm border">
                        {/* <div className="overflow-x-auto"> */}
                        <div className="overflow-x-auto max-h-[500px] overflow-y-auto relative">

                            <table className="min-w-full divide-y divide-gray-200">
                                {/* <thead className="bg-gray-50"> */}
                                <thead className="bg-gray-50 sticky top-0 z-10">
                                    <tr>
                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Select</th>
                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Service</th>
                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Invoice</th>
                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Movie</th>
                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Transaction</th>
                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Show Date</th>
                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Amount</th>
                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Total Payable</th>
                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Base Amount</th>
                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Taxes on Base Amount</th>
                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Gateway Charges</th>
                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Platform Fee Collection</th>
                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Platform Tax</th>
                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Bank Details</th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-gray-200">


                                    {[...filteredEntries]
                                        .sort((a, b) => {
                                            const invA = a.invoiceNumber || '';
                                            const invB = b.invoiceNumber || '';
                                            return invA.localeCompare(invB, undefined, { numeric: true });
                                        })
                                        .map((entry, index) => (

                                            // {filteredEntries?.map((entry, index) => (
                                            <tr
                                                key={index}
                                                className={`hover:bg-gray-50 ${entry.status === 'Matched' && !selectedEntries.some(e => e.transactionId === entry.transactionId)
                                                    ? 'bg-red-50'
                                                    : ''
                                                    } ${entry.status === 'NA' ? 'bg-blue-50' : ''}`}
                                            >
                                                <td>
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedEntries.some(e => e.transactionId === entry.transactionId)}
                                                        onChange={() => {
                                                            if (selectedEntries.some(e => e.transactionId === entry.transactionId)) {
                                                                setSelectedEntries(selectedEntries.filter(e => e.transactionId !== entry.transactionId));
                                                            } else {
                                                                setSelectedEntries([...selectedEntries, entry]);
                                                            }
                                                        }}
                                                        // disabled={!['Matched', 'NA'].includes(entry.status)}
                                                        disabled={!['Matched', 'NA', 'Refunded'].includes(entry.status)}
                                                    />
                                                </td>
                                                <td className="px-4 py-3 whitespace-nowrap">
                                                    <span className={`px-2 py-1 text-xs rounded-full ${entry.serviceType === 'taxi' ? 'bg-blue-100 text-blue-800' : 'bg-purple-100 text-purple-800'
                                                        }`}>
                                                        {entry.serviceType}
                                                    </span>
                                                </td>
                                                <td className="px-4 py-3 whitespace-nowrap">
                                                    {entry.invoiceNumber || 'N/A'}
                                                </td>
                                                <td className="px-4 py-3 whitespace-nowrap">
                                                    {entry.serviceType === 'theater' ? (entry.movieName || 'N/A') : '-'}
                                                </td>
                                                <td className="px-4 py-3 whitespace-nowrap">
                                                    {entry.transactionId || 'N/A'}
                                                </td>
                                                <td className="px-4 py-3 whitespace-nowrap">
                                                    {entry.serviceType === 'theater' && entry.showDate ? new Date(entry.showDate).toLocaleDateString('en-IN') : '-'}
                                                </td>
                                                <td className="px-4 py-3 whitespace-nowrap">
                                                    ₹{entry?.customerAmount?.toFixed(2)}
                                                </td>
                                                <td className="px-4 py-3 whitespace-nowrap">
                                                    ₹{entry?.payableToPartner?.toFixed(2)}
                                                </td>
                                                <td className="px-4 py-3 whitespace-nowrap">
                                                    ₹{entry?.baseAmount?.toFixed(2)}
                                                </td>
                                                <td className="px-4 py-3 whitespace-nowrap">
                                                    ₹{entry?.taxes?.toFixed(2)}
                                                </td>
                                                <td className="px-4 py-3 whitespace-nowrap">
                                                    ₹{entry?.gatewayCharges?.toFixed(2)}
                                                </td>
                                                <td className="px-4 py-3 whitespace-nowrap">
                                                    ₹{entry?.platformEarnings?.toFixed(2)}
                                                </td>
                                                <td className="px-4 py-3 whitespace-nowrap">
                                                    ₹{entry?.platformTax?.toFixed(2)}
                                                </td>
                                                <td className="px-4 py-3 whitespace-nowrap">
                                                    <span className={`px-2 py-1 text-xs rounded-full ${entry.status === 'Matched' ? 'bg-green-100 text-green-800' :
                                                        entry.status === 'NA' ? 'bg-gray-100 text-gray-800' : 'bg-yellow-100 text-yellow-800'
                                                        }`}>
                                                        {entry?.status}
                                                    </span>
                                                </td>
                                                <td className="px-4 py-3 whitespace-nowrap">
                                                    {entry.serviceType === 'taxi' && entry.riderBankDetails ? (
                                                        <div className="text-xs">
                                                            <p><strong>Bank:</strong> {entry.riderBankDetails.bankName}</p>
                                                            <p><strong>Account:</strong> {entry.riderBankDetails.accountNumber}</p>
                                                            <p><strong>IFSC:</strong> {entry.riderBankDetails.IFSC}</p>
                                                        </div>
                                                    ) : entry.serviceType === 'theater' && entry.theaterBankDetails ? (
                                                        <div className="text-xs">
                                                            <p><strong>Bank:</strong> {entry.theaterBankDetails.bankName}</p>
                                                            <p><strong>Account:</strong> {entry.theaterBankDetails.accountNumber}</p>
                                                            <p><strong>IFSC:</strong> {entry.theaterBankDetails.ifscCode}</p>
                                                        </div>
                                                    ) : 'N/A'}
                                                </td>
                                            </tr>
                                        ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* Unselected Matched Transactions Section */}
                    {selectedEntries.length < matchedTotals.count && (
                        <div className="mt-6 border rounded-lg overflow-hidden">
                            <button
                                className="w-full px-4 py-3 bg-gray-100 text-left font-medium flex justify-between items-center"
                                onClick={() => setShowUnselected(!showUnselected)}
                            >
                                <span>
                                    Unselected Matched Transactions ({matchedTotals.count - selectedEntries.length})
                                </span>
                                <svg
                                    className={`h-5 w-5 transform ${showUnselected ? 'rotate-180' : ''}`}
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                >
                                    <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                                </svg>
                            </button>
                            {showUnselected && (
                                <div className="p-4 bg-white">
                                    <table className="min-w-full divide-y divide-gray-200">
                                        <thead className="bg-gray-50">
                                            <tr>
                                                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Service</th>
                                                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Transaction</th>
                                                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Amount</th>
                                                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Payable</th>
                                                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Bank Details</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {localReportData.summary.detailedEntries
                                                .filter(entry =>
                                                    entry.status === 'Matched' &&
                                                    !selectedEntries.some(e => e.transactionId === entry.transactionId)
                                                )
                                                .map((entry, index) => (
                                                    <tr key={`unselected-${index}`} className="hover:bg-gray-50">
                                                        <td className="px-4 py-3 whitespace-nowrap">
                                                            <span className={`px-2 py-1 text-xs rounded-full ${entry.serviceType === 'taxi' ? 'bg-blue-100 text-blue-800' : 'bg-purple-100 text-purple-800'
                                                                }`}>
                                                                {entry.serviceType}
                                                            </span>
                                                        </td>
                                                        <td className="px-4 py-3 whitespace-nowrap">
                                                            {entry.transactionId || 'N/A'}
                                                        </td>
                                                        <td className="px-4 py-3 whitespace-nowrap">
                                                            ₹{entry.customerAmount.toFixed(2)}
                                                        </td>
                                                        <td className="px-4 py-3 whitespace-nowrap">
                                                            ₹{entry.payableToPartner.toFixed(2)}
                                                        </td>
                                                        <td className="px-4 py-3 whitespace-nowrap">
                                                            {entry.serviceType === 'taxi' && entry.riderBankDetails ? (
                                                                <div className="text-xs">
                                                                    <p><strong>Bank:</strong> {entry.riderBankDetails.bankName}</p>
                                                                    <p><strong>Account:</strong> {entry.riderBankDetails.accountNumber}</p>
                                                                </div>
                                                            ) : entry.serviceType === 'theater' && entry.theaterBankDetails ? (
                                                                <div className="text-xs">
                                                                    <p><strong>Bank:</strong> {entry.theaterBankDetails.bankName}</p>
                                                                    <p><strong>Account:</strong> {entry.theaterBankDetails.accountNumber}</p>
                                                                </div>
                                                            ) : 'N/A'}
                                                        </td>
                                                    </tr>
                                                ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                    )}


                </div>
            )}
        </div>
    );
};

export default Step3;
